import React from 'react'
import Header from "../header/header";
import Menu from "../menu/menu";
import Cards from "../cards/cards";
import { useFindMenuId } from "../menu/utils";

const Chemistry = () => {
    return <div>
        <Header />
        <Menu/>
        <Cards item_id={useFindMenuId()} />
    </div>
}

export default Chemistry